"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9907],{

/***/ 9907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Video; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Video-232035c2.mjs
var Video_232035c2 = __webpack_require__(970);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(7650);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
;// CONCATENATED MODULE: ./src/service/schemaOrg/generators/video.ts


/**
 * Extracts embed URL from iframe HTML string
 */ function extractEmbedUrl(embedHtml) {
    if (!embedHtml) return undefined;
    var regex = /src="([^"]*)"/;
    var match = embedHtml.match(regex);
    return match ? match[1] : undefined;
}
/**
 * Generates VideoObject schema for a Video component
 * Returns null if required fields are missing
 */ function generateVideoObjectSchema(params) {
    var title = params.title, caption = params.caption, videoType = params.videoType, video = params.video, image = params.image, youtubeVideoUrl = params.youtubeVideoUrl, icareus = params.icareus;
    // Title is required for video schema
    if (!title) {
        return null;
    }
    // Get thumbnail URL from image
    var thumbnailUrl;
    if (image === null || image === void 0 ? void 0 : image["@link"]) {
        thumbnailUrl = app/* __APP_HOST_PUBLIC__ */.jT + image["@link"];
    }
    // Build base schema
    var schema = {
        "@type": "VideoObject",
        name: title
    };
    // Add description if available
    if (caption) {
        schema.description = caption;
    }
    // Add thumbnail if available
    if (thumbnailUrl) {
        schema.thumbnailUrl = thumbnailUrl;
    }
    // Add video-specific URLs based on type
    if (videoType === "youtube" && youtubeVideoUrl) {
        var embedUrl = youtubeVideoUrl.replace("watch?v=", "embed/");
        schema.embedUrl = embedUrl;
    } else if (videoType === "icareus" && icareus) {
        var embedUrl1 = extractEmbedUrl(icareus);
        if (embedUrl1) {
            schema.embedUrl = embedUrl1;
        }
    } else if (videoType === "asset" && video) {
        var ref;
        if (video["@link"]) {
            schema.contentUrl = app/* __APP_HOST_PUBLIC__ */.jT + video["@link"];
        }
        // Add encoding format if available
        if ((ref = video.metadata) === null || ref === void 0 ? void 0 : ref.mimeType) {
            schema.encodingFormat = video.metadata.mimeType;
        }
    }
    // Add publisher (Business Finland)
    schema.publisher = {
        "@type": "Organization",
        name: "Business Finland"
    };
    return schema;
}
/**
 * Converts VideoObject schema to JSON-LD string
 */ function videoSchemaToJsonLd(schema) {
    if (!schema) return "";
    var schemaWithContext = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org"
    }, schema);
    return JSON.stringify(schemaWithContext);
}

;// CONCATENATED MODULE: ./src/magnolia/components/Video/Video.tsx






function ensureIframeTitle(embed, title) {
    return embed.replace('title=""', 'title="'.concat(title, '"'));
}
function Video(param) {
    var title = param.title, caption = param.caption, autoplay = param.autoplay, image = param.image, imageAlt = param.imageAlt, videoType = param.videoType, video = param.video, youtubeVideoUrl = param.youtubeVideoUrl, icareus = param.icareus;
    var isPreview = (0,router.useRouter)().isPreview;
    var derivedVideoType = "";
    var videoSrc = "";
    var imgSrc = "";
    var mimeType = "";
    var embedCode = "";
    if (videoType === "asset") {
        var ref;
        derivedVideoType = "asset";
        videoSrc = (0,magnolia/* getAssetPath */.K3)(video, isPreview);
        var ref1;
        mimeType = (ref1 = (ref = video.metadata) === null || ref === void 0 ? void 0 : ref.mimeType) !== null && ref1 !== void 0 ? ref1 : "";
    }
    if (image) {
        imgSrc = (0,magnolia/* getAssetPath */.K3)(image, isPreview);
    }
    if (videoType === "youtube") {
        if (!youtubeVideoUrl) {
            return null;
        }
        derivedVideoType = "embed";
        embedCode = '\n      <iframe\n        src="'.concat(youtubeVideoUrl.replace("watch?v=", "embed/"), '"\n        title="').concat(title || "Youtube video", '"\n        allowfullscreen\n        enablejsapi\n      ></iframe>\n    ');
    }
    var sanitizedData = function() {
        return browser_default().sanitize(icareus, {
            ADD_TAGS: [
                "iframe"
            ],
            ADD_ATTR: [
                "allow",
                "autoplay",
                "allowfullscreen",
                "frameborder",
                "scrolling", 
            ]
        });
    };
    if (videoType === "icareus") {
        derivedVideoType = "icareusIframe";
        embedCode = sanitizedData();
        embedCode = ensureIframeTitle(embedCode || "", title || "Embedded video");
    }
    // Generate video schema JSON-LD
    var videoSchema = generateVideoObjectSchema({
        title: title,
        caption: caption,
        videoType: videoType,
        video: video,
        image: image,
        youtubeVideoUrl: youtubeVideoUrl,
        icareus: icareus
    });
    var videoSchemaJsonLd = videoSchemaToJsonLd(videoSchema);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            videoSchemaJsonLd && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                nonce: "5274deac-df2c-4405-9816-123c1b001d19",
                dangerouslySetInnerHTML: {
                    __html: videoSchemaJsonLd
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Video_232035c2.V, {
                title: imageAlt && imgSrc ? imageAlt : title,
                caption: caption,
                image: imgSrc,
                video: {
                    src: videoSrc,
                    mimeType: mimeType
                },
                autoplay: autoplay,
                embed: embedCode,
                videoType: derivedVideoType,
                styling: Video_232035c2.a.ARTICLE
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/Video/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 970:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ h; },
/* harmony export */   "a": function() { return /* binding */ C; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4877);



const A = "video", f = "video__hero", g = "video__article", k = "desktop", P = "video__caption", d = {
  video: A,
  videoHero: f,
  videoArticle: g,
  desktop: k,
  videoCaption: P
};
var C = /* @__PURE__ */ ((t) => (t.ARTICLE = "videoArticle", t.HERO = "videoHero", t))(C || {});
function h({
  title: t,
  caption: s,
  styling: i,
  autoplay: l,
  embed: o,
  image: u = "",
  videoType: c,
  video: r,
  viewport: m
}) {
  const E = Array.isArray(r) ? r.find((y) => m && y.device?.includes(m)) : r, a = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(d.video, i && d[i]), p = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, c === "icareusIframe" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ), c === "embed" && (o?.includes("iframe") ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-embed",
      itemProp: "video",
      title: t,
      className: a,
      src: o,
      playsInline: !0,
      controls: !0
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )), c === "asset" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, l ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset",
      itemProp: "video",
      title: t,
      className: a,
      src: E?.src,
      autoPlay: l,
      loop: !0,
      muted: !0,
      playsInline: !0
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset-control",
      itemProp: "video",
      title: t,
      className: a,
      controls: !0,
      poster: u,
      playsInline: !0
    },
    !Array.isArray(r) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { src: r.src, type: r.mimeType }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )));
  return i === "videoArticle" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B,
    {
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.LARGE,
      "data-testid": "article-video"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Content, { "data-testid": "article-video-content" }, p, s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsCaption, d.videoCaption) }, s))
  )) : p;
}

//# sourceMappingURL=Video-232035c2.mjs.map


/***/ })

}]);